import { RootState } from '..';
import { getNestedField } from '../utils';

export const getModal =
  (state: RootState) =>
  <T extends FlattenKeys<ModalState>>(field: T) =>
    getNestedField(state.modal, field);

const modalGetters = (state: RootState) => ({
  getModal: getModal(state),
});

export default modalGetters;
